import { safeSessionStorage } from "./storage";

const SOFTWALL_REDIRECT_KEY = "BT_AM_SOFTWALL_REDIRECT";

export const hasRedirectData = () =>
  safeSessionStorage.get(SOFTWALL_REDIRECT_KEY) === "true";

export const saveRedirectData = () =>
  safeSessionStorage.set(SOFTWALL_REDIRECT_KEY, "true");
export const deleteRedirectData = () =>
  safeSessionStorage.remove(SOFTWALL_REDIRECT_KEY);
